import Icon from '@/components/ui/AppIcon';

interface SecurityBadge {
  id: string;
  icon: string;
  label: string;
  description: string;
}

const SecurityBadges = () => {
  const badges: SecurityBadge[] = [
    {
      id: 'hipaa',
      icon: 'ShieldCheckIcon',
      label: 'HIPAA Compliant',
      description: 'Your health data is protected with industry-leading security standards'
    },
    {
      id: 'ssl',
      icon: 'LockClosedIcon',
      label: 'SSL Encrypted',
      description: 'All data transmission is secured with 256-bit encryption'
    },
    {
      id: 'verified',
      icon: 'CheckBadgeIcon',
      label: 'Verified Platform',
      description: 'Certified by healthcare regulatory authorities'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {badges.map((badge) => (
        <div 
          key={badge.id}
          className="flex flex-col items-center text-center p-6 bg-card border border-border rounded-lg"
        >
          <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4">
            <Icon 
              name={badge.icon as any} 
              size={24} 
              className="text-primary"
            />
          </div>
          <h3 className="font-heading font-semibold text-foreground mb-2">
            {badge.label}
          </h3>
          <p className="text-sm text-muted-foreground">
            {badge.description}
          </p>
        </div>
      ))}
    </div>
  );
};

export default SecurityBadges;